<template>
  <div class="contact-form general">
    <div class="form-row">
      <RadioButtonGroup inline>
        <RadioButton :label="labels.get('Mr')" value="Mr." v-model="formData.title"></RadioButton>
        <RadioButton :label="labels.get('Mrs')" value="Ms." v-model="formData.title"></RadioButton>
        <RadioButton :label="labels.get('Mx')" value="Mx." v-model="formData.title"></RadioButton>
        <RadioButton :label="labels.get('Dr')" value="Dr." v-model="formData.title"></RadioButton>
      </RadioButtonGroup>
    </div>

    <div class="form-row">
      <TextBox :label="labels.get('Your name')" v-model="formData.firstName" :invalid="invalidFields.firstName"
        :placeholder="labels.get('First name')" mandatory @change="validateField('firstName')"></TextBox>
      <TextBox :label="labels.get('Last name')" v-model="formData.lastName" :placeholder="labels.get('Last name')"
        @change="validateField('lastName')" :invalid="invalidFields.lastName" mandatory></TextBox>
    </div>
    <div class="form-row">
      <TextBox :label="labels.get('Your email')" v-model="formData.email" @change="validateField('email')"
        :invalid="invalidFields.email" :placeholder="labels.get('Email address')" mandatory></TextBox>
      <TextBox :label="labels.get('Phone')" v-model="formData.phone" :placeholder="labels.get('Phone number')">
      </TextBox>
    </div>
    <div class="form-row">
      <TextBox :label="labels.get('Your company')" v-model="formData.company" :placeholder="labels.get('Company name')">
      </TextBox>
      <DropList :label="labels.get('Country')" :data="countries" v-model="formData.countryId" filterable mandatory
        @change="onCountryChanged"></DropList>
    </div>
    <div>
      <NoteBox :label="labels.get('Message')" v-model="formData.message" @change="validateField('message')"
        :invalid="invalidFields.message" :placeholder="labels.get('Your message here')" :rows="5" class="messagebox"
        mandatory>
      </NoteBox>
    </div>
    <div>
      <CheckboxGroup>
        <Checkbox :label="labels.get('Ack1')" mandatory v-model="formData.ack1" :invalid="invalidFields.ack1"
          @change="validateField('ack1')"></Checkbox>
        <Checkbox :label="labels.get('Ack2')" v-model="formData.ack2"></Checkbox>
      </CheckboxGroup>
    </div>
    <div class="button-container">
      <FlatButton blue :label="labels.get('Submit')" inline-right @click="submitForm"></FlatButton>
    </div>
  </div>
</template>

<script>
import {
  RadioButtonGroup,
  RadioButton,
  NoteBox,
  TextBox,
  DropList,
  CheckboxGroup,
  Checkbox,
  FlatButton
} from "clariant-vue3-forms";
import { Labels, Config, DataLayer, Utils, State, Monitoring } from "../services.js";

export default {
  name: "ContactForm",
  components: {
    RadioButtonGroup,
    RadioButton,
    NoteBox,
    TextBox,
    DropList,
    CheckboxGroup,
    Checkbox,
    FlatButton
  },
  props: ["tag", "bu", "bl", "country", "region", "contact"],
  data() {
    return {
      labels: Labels,
      config: Config,
      utils: Utils,
      dataLayer: DataLayer,
      formData: {
        contact: null,
        title: "Mr.",
        message: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        countryId: "",
        countryName: "",
        ack1: false,
        ack2: false,
      },
      invalidFields: {
        firstName: false,
        lastName: false,
        email: false,
        message: false,
        ack1: false,
      },
      countries: [],
    };
  },
  setup() {
    return {
      uniqueId: `ContactForm-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`
    }
  },
  async mounted() {
    let loader = Utils.showLoader("#app");
    try {
      Monitoring.startActivity("List of countries load");
      if (!State.countries) {

        this.countries = await DataLayer.getCountries();
        State.set("countries", this.countries);
      } else {
        this.countries = await DataLayer.getCountries();
      }
      if (this.country) {
        const countryEntry = this.countries.find(x => x.name === this.country);
        if (countryEntry) {
          this.formData.countryId = countryEntry.id;
          this.formData.countryName = countryEntry.name;
        }
      }
    } catch (err) {
      Utils.showStatusMessage(`Could not load country list! ${err}.`, "red", 5000);
    } finally {
      Utils.removeLoader(loader);
      Monitoring.endActivity("List of countries load");
    };
    this.formData.country = claGetCookie("CLACountry")?.toLowerCase();
  },
  beforeUnmount() {

  },
  watch: {
    contact(val) {
      this.formData.contact = val;
    },
  },
  methods: {
    clearForm() {
      this.formData.message = "";
      this.invalidFields.message = false;
      this.invalidFields.ack1 = false;
      this.invalidFields.firstName = false;
      this.invalidFields.lastName = false;
      this.invalidFields.email = false;
    },
    onCountryChanged(e) {
      if (e.value) {
        State.set("country", e.value);
        this.formData.countryName = e.label;
      }
    },
    validateField(fieldName) {
      if (fieldName === "email") {
        this.invalidFields[fieldName] = !this.utils.isEmail(
          this.formData[fieldName]
        );
      } else {
        this.invalidFields[fieldName] = !this.formData[fieldName];
      }
      return !this.invalidFields[fieldName];
    },
    validateForm() {
      let ret = true;
      if (!this.validateField("firstName")) ret = false;
      if (!this.validateField("lastName")) ret = false;
      if (!this.validateField("email")) ret = false;
      if (!this.validateField("message")) ret = false;
      if (!this.validateField("ack1")) ret = false;

      return ret;
    },
    getFormPayload() {
      return this.formData;
    },
    submitForm() {
      if (this.validateForm()) {
        this.$emit("submit-form", this.formData);
      }
    }
  },
};
</script>

<style>
.contact-form {
  width: 800px;
  max-width: 100%;
}

.contact-form.general .form-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.contact-form.general .form-row>* {
  width: 48% !important;
  align-self: flex-end;
  flex-wrap: wrap;
}

.contact-form.general .messagebox textarea {
  height: 100px;
}

.contact-form.general .cla-droplist-container .options-container {
  max-height: 170px !important;
}

.contact-form .button-container {
  display: flex;
  justify-content: flex-end;
}

@media all and (max-width: 980px) {
  .contact-form.general .form-row {
    flex-direction: column;
  }

  .contact-form.general .form-row>* {
    width: 100% !important;
  }
}
</style>